import { render, staticRenderFns } from "./shipmentsdispatched.vue?vue&type=template&id=a3cc1650&scoped=true"
import script from "./shipmentsdispatched.vue?vue&type=script&lang=js"
export * from "./shipmentsdispatched.vue?vue&type=script&lang=js"
import style0 from "./shipmentsdispatched.vue?vue&type=style&index=0&id=a3cc1650&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3cc1650",
  null
  
)

export default component.exports